import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import axios from 'axios';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Step',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      step: {
        actualTime: 0,
        comment: '',
        conditionComment: '',
        conditionId: 1,
        conditionName: '',
        name: '',
        elemenTypeName: '',
        elementId: 0,
        elementName: '',
        elementTypeId: 0,
        outcomeId: 0,
        outcomeName: '',
        outcomeTypeId: 0,
        outcomeTypeName: '',
        reading: null,
        readingDt: '',
        serialNumber: '',
        stepId: 0,
        //unit: null,
        //unitId: -1,
        uuid: ''
      },
      unit: {
        disabled: false,
        group: null,
        selected: false,
        text: "",
        value: "0",
      },
      unitType: {
        disabled: false,
        group: null,
        selected: false,
        text: "",
        value: "0",
      },
      conditions: [],
      elementConditions: [],
      allOutcomes: [],
      allUnits: [],
      outcomes: [],
      outcomeTypes: [],
      bHasSerial: false,
    }
  },
  computed: {
    outcomeTypeId: function () {
      return this.step.outcomeTypeId;
    },
  },
  validations: {
    outcomeType: {
      required
    },
    outcome: {
      required
    },
    condition: {
      required
    },
  },
  watch: {
    outcomeTypeId: function (value) {
      if (!value)
        return;
      this.outcomes = this.allOutcomes.filter(item => item.outcomeTypeId === value);
    },
    unitType: function (value) {
      if (!value)
        return;
      //this.dataObj.unitTypeId = value.value;
      //this.dataObj.unitType = value.text;
      //this.dataObj.units = this.allUnits.filter(p => p.group.name === value.value);
    },
    unit: function (value) {
      if (!value)
        return;
      //this.dataObj.unitId = value.value;
      //this.dataObj.unit = value.displayString;
    },
  },
  created() {
    this.getLookups();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.step = this.dataObj;
        this.step.outcomeId = this.step.outcomeTypeId + '-' + this.step.outcomeId;
        //this.allUnits = this.dataObj.units;
        //this.unit = this.allUnits.filter(p => p.value === this.dataObj.unitId)[0];
        //if (this.unit)
        //  this.unitType = this.dataObj.unitTypes.filter(p => p.value === this.unit.group.name)[0];
      });
    },
    setSelectedOutcomeType(value) {
      this.step.outcomeTypeName = this.outcomeTypes.filter(p => p.outcomeTypeId === value)[0].displayString;
    },
    setSelectedOutcome(value) {
      let outcome = this.outcomes.filter(p => p.id === value)[0];
      this.bHasSerial = outcome.hasSerial;
      this.step.outcomeName = outcome.displayString;
    },
    setSelectedCondition(value) {
      //console.log(value);
    },
    getLookups() {
      axios.post('/JobcardStep/GetLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.item.outcomes.forEach(item => {
              item.originalId = item.id;
              item.id = item.outcomeTypeId + '-' + item.id;
            });
            this.outcomes = [];
            this.allOutcomes = response.data.item.outcomes;
            this.outcomeTypes = response.data.item.outcomeTypes;
            this.elementConditions = response.data.item.elementConditions;
            let outcome = this.allOutcomes.filter(p => p.id === this.step.outcomeId)[0];
            if (outcome) {
              this.bHasSerial = outcome.hasSerial;
              this.step.outcomeName = outcome.displayString;
            }
            this.conditions = this.step.elementTypeId ? this.elementConditions[this.step.elementTypeId] : this.elementConditions[0]
            if (this.step.outcomeTypeId > 0)
              this.outcomes = this.allOutcomes.filter(item => item.outcomeTypeId === this.step.outcomeTypeId);
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => {
          this.$router.push('/login');
          return false;
        })
    },
  },
}

